import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries, get } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

checkoutReviewAndSubmitHeaderStyles.buttonsWrapper = mergeToNew(checkoutReviewAndSubmitHeaderStyles.buttonsWrapper, {
    css: css`
        display: flex;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    position: fixed;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    background: ${getColor("common.background")({ theme })};
                    justify-content: center;
                    z-index: ${get(theme, "zIndex.stickyFooter")};
                    padding: 10px;
                `,
                css`
                    margin-left: 16px;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
                css`
                    margin-left: auto;
                `,
            ])}
    `,
});
